import { ContactForm } from '@components';
import { formPostPath } from '@paths';
import { usePardot } from '@hooks';

export const ContactFormSection: React.FC<{
  className?: string;
  category?: string;
  pardotUrl?: string | null;
}> = ({ className = '', category, pardotUrl }) => {
  const { onSubmit } = usePardot(pardotUrl);
  return (
    <section
      className={`w-full bg-lightgray py-14 ${className}`}
      id='contact-form'
    >
      <div className='container mx-auto mt-14 lg:px-16 xl:px-24'>
        <h2 className='text-center text-3xl'>
          <b>
            発注先探しの
            <br className='sm:hidden' />
            ご相談フォーム
          </b>
        </h2>
        <div className='my-7 text-center text-base'>
          発注ナビは貴社の発注先探しを
          <br className='sm:hidden' />
          徹底的にサポートします。
          <br />
          お気軽にご相談下さい。
        </div>
        <ContactForm
          formPostPath={formPostPath}
          category={category}
          onSubmit={onSubmit}
        />
      </div>
    </section>
  );
};
